<p-toast position="top-right"></p-toast>

<div *ngIf="form" class="flex flex-col" [formGroup]="form">
    <!-- HEADER sticky -->
    <div class="card mb-3 si-sticky-header">
        <div class="flex flex-wrap items-center justify-between gap-3">
            <div>
                <div class="font-semibold text-xl leading-tight">{{ title }}</div>
                <div class="text-sm text-gray-500">Scheda interventi</div>
            </div>
            <div class="flex items-center gap-2">
                <button pButton type="button" label="Annulla" severity="secondary" [outlined]="true" (click)="annulla()"></button>
                <button *ngIf="!isReadonly" pButton type="button" icon="pi pi-save" label="Salva" class="p-button-success" [disabled]="saving" (click)="salva()"></button>
            </div>
        </div>
    </div>

    <!-- CONTENUTO -->
    <div class="card">
        <!-- DATI INTERVENTO -->
        <section class="si-section">
            <div class="si-section-title">Dati intervento</div>
            <div class="si-grid">
                <div class="si-field">
                    <label for="dataInizioLavoro">Data inizio lavoro <span class="req">*</span></label>
                    <p-datePicker inputId="dataInizioLavoro" formControlName="dataInizioLavoro" [showTime]="true" hourFormat="24" dateFormat="dd/mm/yy" showIcon="true" styleClass="w-full"></p-datePicker>
                </div>
                <div class="si-field">
                    <label for="dataVerifica">Data verifica</label>
                    <p-datePicker inputId="dataVerifica" formControlName="dataVerifica" [showTime]="true" hourFormat="24" dateFormat="dd/mm/yy" showIcon="true" styleClass="w-full"></p-datePicker>
                </div>
                <div class="si-field si-field-full">
                    <label for="descrizioneIntervento">Descrizione <span class="req">*</span></label>
                    <textarea rows="4" pTextarea id="descrizioneIntervento" formControlName="descrizioneIntervento" [readonly]="isReadonly" class="w-full"></textarea>
                </div>
            </div>

            <div class="si-subtitle">Tipo intervento</div>
            <div class="si-checks">
                <div class="si-check">
                    <p-checkbox inputId="interventoGenericoFlg" binary="true" formControlName="interventoGenericoFlg"></p-checkbox>
                    <label for="interventoGenericoFlg">Intervento generico</label>
                </div>
                <div class="si-check">
                    <p-checkbox inputId="revisioneDeviatoioFlg" binary="true" formControlName="revisioneDeviatoioFlg"></p-checkbox>
                    <label for="revisioneDeviatoioFlg">Revisione deviatoio</label>
                </div>
                <div class="si-check">
                    <p-checkbox inputId="sostituzioneDeviatoioFlg" binary="true" formControlName="sostituzioneDeviatoioFlg"></p-checkbox>
                    <label for="sostituzioneDeviatoioFlg">Sostituzione deviatoio</label>
                </div>
            </div>
        </section>

        <!-- ESITO -->
        <section class="si-section">
            <div class="si-section-title">Esito</div>
            <div class="si-checks">
                <div class="si-check">
                    <p-checkbox inputId="flgEsitoPositivo" binary="true" formControlName="flgEsitoPositivo"></p-checkbox>
                    <label for="flgEsitoPositivo">Positivo</label>
                </div>
                <div class="si-check">
                    <p-checkbox inputId="flgEsitoNegativo" binary="true" formControlName="flgEsitoNegativo"></p-checkbox>
                    <label for="flgEsitoNegativo">Negativo</label>
                </div>
                <div class="si-check">
                    <p-checkbox inputId="flgEsitoPositivoConRiserva" binary="true" formControlName="flgEsitoPositivoConRiserva"></p-checkbox>
                    <label for="flgEsitoPositivoConRiserva">Positivo con riserva</label>
                </div>
            </div>
        </section>

        <!-- NOTE -->
        <section class="si-section">
            <div class="si-section-title">Note</div>
            <div class="si-grid">
                <div class="si-field">
                    <label for="noteInterventoRilevatore">Note rilevatore</label>
                    <textarea rows="4" pTextarea id="noteInterventoRilevatore" formControlName="noteInterventoRilevatore" class="w-full" [readonly]="isReadonly"></textarea>
                </div>
                <div class="si-field">
                    <label for="noteInterventoAssegnatore">Note assegnatore</label>
                    <textarea rows="4" pTextarea id="noteInterventoAssegnatore" formControlName="noteInterventoAssegnatore" class="w-full" [readonly]="isReadonly"></textarea>
                </div>
            </div>
        </section>
    </div>
</div>
